import React, { useEffect, useState } from "react";
import { Link } from "react-router-dom";
import { api } from "../lib/api";
import { CheckCircle, Clock, AlertTriangle, Loader2, ListChecks, ChevronRight } from "lucide-react";
import { toast } from "sonner";

const COL_LABELS = { todo: "To Do", in_progress: "In Progress", blocked: "Blocked", done: "Done" };
const COL_COLORS = {
  todo: "bg-gray-50 border-gray-200",
  in_progress: "bg-blue-50 border-blue-200",
  blocked: "bg-rose-50 border-rose-200",
  done: "bg-emerald-50 border-emerald-200",
};

export default function DesignerTasks() {
  const [board, setBoard] = useState({ columns: {}, statuses: ["todo", "in_progress", "blocked", "done"] });
  const [filter, setFilter] = useState("all");

  const load = () => api.get("/designer/tasks/board").then(r => setBoard(r.data));
  useEffect(() => { load(); const t = setInterval(load, 60000); return () => clearInterval(t); }, []);

  const setStatus = async (tid, status) => {
    try { await api.put(`/designer/tasks/${tid}`, { status }); toast.success("Updated"); load(); }
    catch { toast.error("Failed"); }
  };

  return (
    <div className="space-y-4" data-testid="designer-tasks">
      <div className="flex items-center justify-between flex-wrap gap-2">
        <h2 className="text-2xl font-bold text-[#1a3c5e] inline-flex items-center gap-2"><ListChecks className="w-6 h-6 text-[#F7941D]" /> My Tasks</h2>
      </div>

      <div className="grid sm:grid-cols-4 gap-3">
        {board.statuses.map(s => (
          <div key={s} className={`rounded-2xl border p-3 ${COL_COLORS[s]}`} data-testid={`dt-stat-${s}`}>
            <div className="text-xs uppercase font-semibold text-gray-600">{COL_LABELS[s]}</div>
            <div className="text-2xl font-bold mt-1">{(board.columns[s] || []).length}</div>
          </div>
        ))}
      </div>

      <div className="grid md:grid-cols-4 gap-3">
        {board.statuses.map(s => (
          <div key={s} className={`rounded-2xl border p-3 min-h-[400px] ${COL_COLORS[s]}`} data-testid={`dt-col-${s}`}>
            <div className="text-xs font-bold uppercase mb-3 text-[#1a3c5e]">{COL_LABELS[s]}</div>
            <div className="space-y-2">
              {(board.columns[s] || []).map(t => (
                <div key={t.id} className="bg-white rounded-xl border border-gray-200 p-3" data-testid={`dt-task-${t.id}`}>
                  <Link to={`/designer/projects/${t.order_id}`} className="block">
                    <div className="font-bold text-sm text-[#1a3c5e]">{t.title}</div>
                    {t.description && <div className="text-xs text-gray-600 mt-0.5 line-clamp-2">{t.description}</div>}
                    <div className="text-[10px] text-gray-500 mt-1">Project #{t.order_id.slice(0, 8).toUpperCase()}</div>
                  </Link>
                  <div className="mt-2 flex items-center gap-1">
                    <span className={`text-[10px] uppercase px-1.5 py-0.5 rounded ${t.priority === "high" ? "bg-rose-100 text-rose-700" : t.priority === "medium" ? "bg-amber-100 text-amber-700" : "bg-gray-100 text-gray-600"}`}>{t.priority}</span>
                    {t.due_date && <span className="text-[10px] text-gray-500">⏰ {t.due_date.slice(0, 10)}</span>}
                  </div>
                  <select value={t.status} onChange={e => setStatus(t.id, e.target.value)} data-testid={`dt-task-status-${t.id}`} className="mt-2 w-full text-xs border border-gray-200 rounded-lg px-2 py-1">
                    {board.statuses.map(x => <option key={x} value={x}>{COL_LABELS[x]}</option>)}
                  </select>
                </div>
              ))}
              {(board.columns[s] || []).length === 0 && <div className="text-center text-xs text-gray-400 py-6">Empty</div>}
            </div>
          </div>
        ))}
      </div>
    </div>
  );
}
